export default __webpack_public_path__ + "static/media/upLeftArrow.edd429d6.png";